import { NavLink } from 'react-router-dom';
import type { ReactNode } from 'react';

export interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  end?: boolean;
}

function IconToday() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M8 3v4M16 3v4M4 10h16" strokeLinecap="round" />
      <circle cx="12" cy="15" r="1.4" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconTomorrow() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M12 4v2M12 18v2M4 12h2M18 12h2M6.5 6.5l1.4 1.4M16.1 16.1l1.4 1.4M6.5 17.5l1.4-1.4M16.1 7.9l1.4-1.4" strokeLinecap="round" />
      <circle cx="12" cy="12" r="3.2" />
    </svg>
  );
}

function IconCalendar() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M8 3v4M16 3v4M4 10h16M8 14h3M13 14h3M8 17h3" strokeLinecap="round" />
    </svg>
  );
}

function IconIdeas() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M9 18h6M10 21h4M12 3a6 6 0 0 1 3.5 10.9c-.9.7-1.5 1.6-1.5 2.6H10c0-1-.6-1.9-1.5-2.6A6 6 0 0 1 12 3z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconProjects() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <rect x="3" y="5" width="8" height="6" rx="1.2" />
      <rect x="13" y="5" width="8" height="6" rx="1.2" />
      <rect x="3" y="13" width="8" height="6" rx="1.2" />
      <rect x="13" y="13" width="8" height="6" rx="1.2" />
    </svg>
  );
}

function IconHabits() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M9 11l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="4" y="4" width="16" height="16" rx="3" />
    </svg>
  );
}

function IconArchive() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <rect x="4" y="6" width="16" height="4" rx="1" />
      <path d="M6 10v8a2 2 0 002 2h8a2 2 0 002-2v-8" strokeLinecap="round" />
      <path d="M10 14h4" strokeLinecap="round" />
    </svg>
  );
}

/** Нижняя панель / мобильное меню: Сегодня · Завтра · Календарь · Идеи · Архив. Без «Проектов» и «Привычек». */
export const primaryNavItems: NavItem[] = [
  { to: '/today', label: 'Сегодня', icon: <IconToday /> },
  { to: '/tomorrow', label: 'Завтра', icon: <IconTomorrow /> },
  { to: '/calendar', label: 'Календарь', icon: <IconCalendar /> },
  { to: '/ideas', label: 'Идеи', icon: <IconIdeas /> },
  { to: '/archive', label: 'Архив', icon: <IconArchive /> },
];

/** Desktop-сайдбар: primary + «Проекты» + «Привычки» (не в нижнюю мобильную панель). */
export const desktopNavItems: NavItem[] = [
  { to: '/today', label: 'Сегодня', icon: <IconToday /> },
  { to: '/tomorrow', label: 'Завтра', icon: <IconTomorrow /> },
  { to: '/calendar', label: 'Календарь', icon: <IconCalendar /> },
  { to: '/ideas', label: 'Идеи', icon: <IconIdeas /> },
  { to: '/projects', label: 'Проекты', icon: <IconProjects /> },
  { to: '/habits', label: 'Привычки', icon: <IconHabits /> },
  { to: '/archive', label: 'Архив', icon: <IconArchive /> },
];

export function NavList({ items, onNavigate }: { items: NavItem[]; onNavigate?: () => void }) {
  return (
    <nav className="flex flex-col gap-1" aria-label="Основная навигация">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          onClick={onNavigate}
          className={({ isActive }) =>
            `tg-nav-item ${isActive ? 'tg-nav-item-active' : ''}`
          }
        >
          {item.icon}
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
